import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import StaffApp from "@/pages/StaffApp";
import OwnerDashboard from "@/pages/OwnerDashboard";
import Splash from "@/components/Splash";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0E0E0E]">
        <Loader2 className="h-8 w-8 animate-spin text-[#E11D2A]" />
      </div>
    );
  }
  if (user === false) return <Login />;
  if (user.role === "owner") return <OwnerDashboard />;
  return <StaffApp />;
}

function App() {
  return (
    <div className="App grain">
      <Splash />
      <AuthProvider>
        <Toaster position="top-right" richColors theme="dark" />
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Gate />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
